import { Flex, FormLabel, Textarea } from "@chakra-ui/react";
import React from "react";

const FormikTextarea = ({ formik, labelText, field }) => {
  return (
    <Flex>
      <FormLabel whiteSpace="nowrap" mb={0}>
        {labelText}
      </FormLabel>
      <Textarea variant="filled" {...formik.getFieldProps(field)} />
    </Flex>
  );
};

export default FormikTextarea;
